import React from 'react';

const CTASection = ({ onOpenModal }) => {
  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Text with Dallas Image */}
          <div>
            <div className="relative h-48 md:h-64 rounded-2xl overflow-hidden mb-8">
              <img 
                src="https://images.unsplash.com/photo-1582407947304-fd86f028f716?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" 
                alt="Dallas Neighborhood" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-propwhiz-blue/20"></div>
              <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full">
                <span className="font-bold text-propwhiz-dark">Dallas, TX</span>
              </div>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-propwhiz-dark mb-6">
              Get Your Free Dallas Cash Offer Today
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Click the button to fill out our quick form. We'll get back to you within 24 hours with a fair cash offer for your Dallas property.
            </p>

            {/* Benefits List with Images */}
            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-md">
                <img src="https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?ixlib=rb-4.0.3&auto=format&fit=crop&w=50&h=50&q=80" alt="Check" className="w-10 h-10 rounded-full object-cover" />
                <div>
                  <h4 className="font-bold text-lg">Fair Cash Offers</h4>
                  <p className="text-gray-600">Competitive prices based on your Dallas home's actual value</p>
                </div>
              </div>
              <div className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-md">
                <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=50&h=50&q=80" alt="Check" className="w-10 h-10 rounded-full object-cover" />
                <div>
                  <h4 className="font-bold text-lg">No Obligation</h4>
                  <p className="text-gray-600">You're free to accept or decline - no pressure ever</p>
                </div>
              </div>
              <div className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-md">
                <img src="https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?ixlib=rb-4.0.3&auto=format&fit=crop&w=50&h=50&q=80" alt="Check" className="w-10 h-10 rounded-full object-cover" />
                <div>
                  <h4 className="font-bold text-lg">Fast Response</h4>
                  <p className="text-gray-600">We'll contact you within 24 hours with your offer</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Call to Action Box instead of inline form */}
          <div className="relative">
            <div className="absolute inset-0 z-0">
              <img 
                src="https://images.unsplash.com/photo-1582407947304-fd86f028f716?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                alt="Dallas Background" 
                className="w-full h-full object-cover rounded-3xl opacity-10"
              />
            </div>
            
            <div className="relative z-10 bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl p-10 text-center border-t-4 border-propwhiz-accent">
              <div className="w-20 h-20 bg-propwhiz-accent/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-propwhiz-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
              </div>
              
              <h3 className="text-3xl font-bold text-propwhiz-dark mb-4">
                Sell Your Dallas House Fast for Cash
              </h3>
              <p className="text-gray-600 mb-8 text-lg">
                Tell us about your property and get a fair, no-obligation cash offer in 24 hours.
              </p>
              
              <button 
                onClick={onOpenModal} 
                className="w-full btn-primary text-xl py-4 bg-propwhiz-accent hover:bg-cyan-600 shadow-xl transition transform hover:-translate-y-1"
              >
                Get My Dallas Cash Offer Now →
              </button>
              
              <p className="text-sm text-gray-500 mt-4">100% Free. Secure & Confidential.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;